import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { allPrivateRoutes } from "..";
import { getAccessibleRoutes } from "@/utils/routeUtils";

const RequiredAuth = ({ children, allowedRoles, excludedRoles = [] }) => {
  const userRoles = useSelector((state) => state.auth.userRoles);

  if (
    userRoles?.length &&
    (!userRoles.some((role) => allowedRoles.includes(role)) ||
      userRoles.some((role) => excludedRoles.includes(role)))
  ) {
    const allAccessibleRoutes = getAccessibleRoutes(
      allPrivateRoutes,
      userRoles
    );
    const firstAccessibleRoute = `/${allAccessibleRoutes[0].path}`;

    return <Navigate to={firstAccessibleRoute} />;
  }

  return children;
};

export default RequiredAuth;
